import { useState, useEffect, useCallback } from 'react'

export function useExitIntent(): { isOpen: boolean; close: () => void } {
  const [isOpen, setIsOpen] = useState(false)
  const [hasShown, setHasShown] = useState(false)

  const close = useCallback(() => {
    setIsOpen(false)
    document.body.style.overflow = ''
  }, [])

  const show = useCallback(() => {
    if (hasShown) return
    setHasShown(true)
    setIsOpen(true)
    document.body.style.overflow = 'hidden'
  }, [hasShown])

  useEffect(() => {
    function handleMouseLeave(e: MouseEvent) {
      if (e.clientY <= 0) {
        show()
      }
    }

    let lastScrollY = window.scrollY
    let scrollTimeout: ReturnType<typeof setTimeout>

    function handleScroll() {
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(() => {
        const currentScrollY = window.scrollY
        if (currentScrollY < lastScrollY - 100 && currentScrollY > 200) {
          show()
        }
        lastScrollY = currentScrollY
      }, 100)
    }

    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        close()
      }
    }

    document.addEventListener('mouseleave', handleMouseLeave)
    window.addEventListener('scroll', handleScroll, { passive: true })
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave)
      window.removeEventListener('scroll', handleScroll)
      document.removeEventListener('keydown', handleKeyDown)
      clearTimeout(scrollTimeout)
    }
  }, [show, close])

  return { isOpen, close }
}
